import { ChatUserStatus } from "@/Modules/Chat/Models/Domain/Chat";
import { UserStatusWebSocket } from "@/Modules/Chat/Models/WebSocket";

export default (status: UserStatusWebSocket | undefined | null): ChatUserStatus | undefined => {
  if (status === UserStatusWebSocket.OFFLINE) {
    return ChatUserStatus.OFFLINE;
  } else if (status === UserStatusWebSocket.ONLINE || status === UserStatusWebSocket.IDLE) {
    return ChatUserStatus.ONLINE;
  } else if (status === UserStatusWebSocket.COMPOSING) {
    return ChatUserStatus.COMPOSING;
  }

  return undefined;
};
